export default __webpack_public_path__ + "static/media/preview.731edf99.jpg";